/**
 * @generated SignedSource<<8b7abd39e1275a2d0167ccb2f66e2c55>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersAppBarAdStatusBase$data = {
  readonly __typename: "Section";
  readonly " $fragmentSpreads": FragmentRefs<"helpersStyleSectionContent">;
  readonly " $fragmentType": "helpersAppBarAdStatusBase";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "helpersAppBarAdStatusBase";
};
export type helpersAppBarAdStatusBase$key = {
  readonly " $data"?: helpersAppBarAdStatusBase$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersAppBarAdStatusBase">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersAppBarAdStatusBase"
};

(node as any).hash = "8b88eb44d8a5627042381a4a03dc2b90";

export default node;
